import { useWindowDimensions } from 'react-native';
export const useWindowHeight = () => {
    const { height } = useWindowDimensions();
    return height;
};
//# sourceMappingURL=useWindowHeight.js.map